/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CardPaymentDetailsDto } from '../../models/card-payment-details-dto';

export interface GetPaymentDetailsCard$Params {
  id: number;
}

export function getPaymentDetailsCard(http: HttpClient, rootUrl: string, params: GetPaymentDetailsCard$Params, context?: HttpContext): Observable<StrictHttpResponse<CardPaymentDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, getPaymentDetailsCard.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CardPaymentDetailsDto>;
    })
  );
}

getPaymentDetailsCard.PATH = '/api/v1/order/{id}/card-payment-details';
